import { temporarilyNotSupport } from '../../utils'

export const setEnableDebug = temporarilyNotSupport('setEnableDebug')
export const getRealtimeLogManager = temporarilyNotSupport('getRealtimeLogManager')
export const getLogManager = temporarilyNotSupport('getLogManager')
